import React, { useState, useEffect } from 'react'
import { Modal } from 'reactstrap'
import { IoIosSend } from 'react-icons/io'
import userApi from '_api/user'
import reportApi from '_api/report'
import { useToasts } from 'react-toast-notifications'
import { FEEDBACK } from '_utils/constant'

const FeedbackCard = () => {
  const { addToast } = useToasts()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const toggle = () => setIsOpenModal((prev) => !prev)

  const onChangeFeedback = (e) => {
    const { value } = e.target
    if (value && error) setError(null)
    setMessage(value)
  }

  const onSubmitFeedback = () => {
    if (!message.trim()) {
      setError('Content cannot be blank')
      return
    }

    setIsSubmitting(true)
    userApi
      .createFeedBack({ type: FEEDBACK, message: message.trim() })
      .then(({ msgCode }) => {
        if (msgCode % 100 === 0) {
          addToast('Thank you!', { appearance: 'success', autoDismiss: true })
          setMessage('')
          setIsOpenModal(false)
        }
      })
      .catch(({ msgResp, msgCode }) => {
        reportApi.report({ message: `${msgCode} - ${msgResp}` })
        addToast(msgResp || 'Failed to submit feedback', {
          appearance: 'error',
          autoDismiss: true,
        })
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  useEffect(() => {
    if (!isOpenModal) {
      setError(null)
      setMessage('')
    }
  }, [isOpenModal])

  return (
    <React.Fragment>
      <div
        className='section-card feedback-card'
        onClick={toggle}
        role='button'
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            toggle()
          }
        }}
      >
        <div className='feedback-row'>
          <div className='feedback-left'>
            <div className='feedback-icon'>
              <IoIosSend size={18} />
            </div>
            <div className='feedback-label'>Feedback</div>
          </div>
          <svg
            width='14'
            height='14'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#009A97'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <polyline points='9 18 15 12 9 6' />
          </svg>
        </div>
      </div>

      <div className='col-12 p-0 feedback-footer-text'>
        <p className='text-center c-txt-9 mb-2'>
          <strong>We appreciate your feedback!</strong>
        </p>
        <p
          style={{
            fontSize: '12px',
            textAlign: 'center',
            marginBottom: '1rem',
            marginTop: '10px',
          }}
        >
          Or drop us an email to:{' '}
          <a href='mailto:friends@co-bee.com'>friends@co-bee.com</a>
        </p>
      </div>

      <Modal
        isOpen={isOpenModal}
        toggle={toggle}
        centered
        className='userv2-modal-dialog'
        contentClassName='userv2-modal-content'
      >
        <div className='userv2-modal-header'>
          <h5 className='userv2-modal-title'>Feedback</h5>
          <button
            type='button'
            className='userv2-modal-close'
            onClick={toggle}
            aria-label='Close'
          >
            <svg
              width='14'
              height='14'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <line x1='18' y1='6' x2='6' y2='18' />
              <line x1='6' y1='6' x2='18' y2='18' />
            </svg>
          </button>
        </div>

        <div className='userv2-modal-body'>
          <div className='userv2-form-group'>
            <textarea
              value={message}
              onChange={onChangeFeedback}
              rows='4'
              placeholder='Content...'
              className={`userv2-textarea ${error ? 'has-error' : ''}`}
            />
            {error && <span className='userv2-field-error'>{error}</span>}
          </div>

          <div className='userv2-modal-footer'>
            <div className='userv2-footer-right'>
              <button
                type='button'
                className='userv2-btn-cancel'
                onClick={toggle}
                disabled={isSubmitting}
              >
                CANCEL
              </button>
              <button
                type='button'
                className='userv2-btn-save'
                onClick={onSubmitFeedback}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'OK'}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default FeedbackCard
